import { Dialog, Transition } from "@headlessui/react";
import React, { useState } from "react";
import TopNavSearch from "../search/TopNavSearch";
import Divider from "../ui-kit/divider/Divider";
import Header from "../ui-kit/header/Header";
import NavbarMenuSvg from "../ui-kit/icons/NavbarMenuSvg";
import LoginArea from "./LoginArea";
import MobileSidenav from "./MobileSidenav";
interface Props {
  title?: string;
  search?: boolean;
}
const TopNav: React.FC<Props> = ({ title, search }) => {
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible((x) => !x);
  };

  return (
    <>
      {/* Desktop */}
      <div className="hidden sm:flex h-[4rem] items-center justify-between px-8">
        <div>
          <Header as="h1" className="text-xl">
            {title}
          </Header>
        </div>
        {search && <TopNavSearch />}
      </div>
      {/* Mobile */}
      <Transition.Root show={menuVisible}>
        <Dialog
          as="div"
          className="fixed inset-0 overflow-hidden"
          onClose={setMenuVisible}
        >
          <div className="absolute inset-0 overflow-hidden">
            <Transition.Child
              enter="ease-in-out duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="absolute inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-y-0 flex">
              <Transition.Child
                enter="transition ease-in-out duration-500 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-500 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <div className="relative w-screen max-w-md">
                  <MobileSidenav toggleMenu={toggleMenu} />
                </div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition
        show={!menuVisible}
        enter="ease-in-out duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in-out duration-75"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div
          className="fixed top-0 z-30 w-full lg:hidden bg-theme-light-bg dark:bg-theme-dark-bg"
          onClick={toggleMenu}
        >
          <div className="flex flex-col flex-1">
            <div className="flex items-center justify-between py-3 mx-4">
              <button>
                <NavbarMenuSvg className="w-8 h-8" />
              </button>

              <div className="">
                <LoginArea />
              </div>
            </div>
            <Divider />
          </div>
        </div>
      </Transition>
    </>
  );
};

TopNav.defaultProps = {
  title: "",
  search: true,
};

export default TopNav;
